// extracted by mini-css-extract-plugin
export default {"stripe-header":"stripe-header--OBt2Nlo5","stripeHeader":"stripe-header--OBt2Nlo5","embeddedLayout":"embeddedLayout--PWLM_SGV"};